import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import toast, { Toaster } from "react-hot-toast";

const CMS = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  let is_alert = false;

  useEffect(() => {
    // return()=>{
    if (location.state !== null) {
      if (is_alert === false) {
        toast.success(location.state);
      }

      is_alert = true;
    }
    window.history.replaceState({}, location.state);

    // }
  }, []);

  const [data, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
  };

  const BuyerLeadData = () => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/cms/get?page=${page}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        setTotalPage(res?.data?.data?.pages);
        setData(res?.data?.data?.docs);
      })
      .catch((err) => {
        if (err.response.data.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const HandleActiveDeactive = (id, status) => {
    let statusText = "";
    let Color = "";
    if (status === true) {
      statusText = "Deactive";
      Color = "#DC3741";
    } else {
      statusText = "Active";
      Color = "#1b55e2";
    }

    Swal.fire({
      title: `Do you want to ${statusText} this Record?`,
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: Color,
      confirmButtonText: statusText,
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .post(
            `${process.env.REACT_APP_URL}/admin/cms/change-status`,
            {
              id: id,
              status: status ? false : true,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("Token")}`,
              },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              toast.success(res.data.message);
              BuyerLeadData();
            }
          })
          .catch((err) => {

            const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
            const STATUS = [401, 403];
            if (
              STATUS.includes(err.response.status) ||
              MSG.includes(err.response.data.msg)
            ) {
              localStorage.clear();
              Navigate("/admin/login");
            } else {
              toast.error(err?.response?.data?.msg);
            }
          });
      }
    });
  };

  const HandleDelete = (e) => {
    Swal.fire({
      title: "Do you want to Delete this Record?",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#DC3741",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .delete(`${process.env.REACT_APP_URL}/admin/cms/delete?id=${e}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              Swal.fire({
                title: "Deleted Sucessfully.",
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
              });
              BuyerLeadData();
            }
          })
          .catch((err) => {

            const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
            const STATUS = [401, 403];
            if (
              STATUS.includes(err.response.status) ||
              MSG.includes(err.response.data.msg)
            ) {
              localStorage.clear();
              Navigate("/admin/login");
            } else {
              toast.error(err?.response?.data?.msg);
            }
          });
      }
    });
  };

  useEffect(() => {
    BuyerLeadData();
  }, [page, search]);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />
      <div className="al-head">
        <div>
          <h1 className="al-title">CMS</h1>
          <p className="al-sub">Manage content entries.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn al-btn--primary" onClick={() => Navigate("/admin/cms/add")}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
            Add CMS
          </button>
        </div>
      </div>

        <div className="al-card">
          <div className="widget-content widget-content-area p-0 box-shadow-none">
            <div className="table-responsive">
              <div
                id="default-ordering_wrapper"
                className="dataTables_wrapper container-fluid dt-bootstrap4"
              >
                <div className="row">
                  <div className="col-sm-12 col-md-10">
                    <div
                      className="dataTables_length"
                      id="default-ordering_length"
                    ></div>
                  </div>
                  <div className="col-sm-12 col-md-2">
                    <div
                      id="default-ordering_filter"
                      className="dataTables_filter"
                    >
                      <label className="d-flex position-relative">
                        <input
                          type="search"
                          className="form-control w-100"
                          placeholder="Search..."
                          aria-controls="default-ordering"
                          onKeyDown={(e) => {
                            e.key === "Enter" &&
                              search !== "" &&
                              BuyerLeadData();
                          }}
                          onChange={(e) => setSearch(e.target.value)}
                          style={{ paddingRight: 10 }}
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <table
                      id="default-ordering"
                      className="table table-hover dataTable"
                      style={{ width: "100%" }}
                      role="grid"
                      aria-describedby="default-ordering_info"
                    >
                      <thead>
                        <tr role="row">
                          <th
                            className="sorting col-1"
                            tabIndex={0}
                            rowSpan={1}
                            colSpan={1}
                            style={{
                              fontSize: "14px",
                              color: "black",
                              textAlign: "center",
                            }}
                          >
                            Name
                          </th>
                          <th
                            className="sorting col-8"
                            tabIndex={0}
                            rowSpan={1}
                            colSpan={1}
                            style={{
                              fontSize: "14px",
                              color: "black",
                              textAlign: "center",
                            }}
                          >
                            Value
                          </th>
                          <th
                            className="sorting col-1"
                            tabIndex={0}
                            rowSpan={1}
                            colSpan={1}
                            style={{
                              fontSize: "14px",
                              color: "black",
                              textAlign: "center",
                            }}
                          >
                            Approved
                          </th>
                          <th
                            className="sorting col-2"
                            tabIndex={0}
                            rowSpan={1}
                            colSpan={9}
                            style={{
                              fontSize: "14px",
                              color: "black",
                              textAlign: "center",
                            }}
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.length !== 0 ? (
                          <>
                            {data?.map((item, index) => (
                              <tr role="row" key={index}>
                                <td
                                  style={{
                                    fontSize: "14px",
                                    color: "black",
                                    textAlign: "center",
                                  }}
                                >
                                  {item?.key}
                                </td>
                                <td
                                  style={{
                                    fontSize: "14px",
                                    color: "black",
                                    maxWidth: "200px", // give enough width for wrapping
                                    overflowWrap: "break-word", // better than wordWrap for modern browsers
                                    wordBreak: "break-word", // force line break on long words
                                    whiteSpace: "normal", // allow text to wrap
                                  }}
                                >
                                  {item?.value?.replace(/<[^>]+>/g, "")}
                                </td>
                                <td
                                  style={{
                                    fontSize: "14px",
                                    color: "black",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "15px",
                                  }}
                                >
                                  <div
                                    onClick={() =>
                                      HandleActiveDeactive(
                                        item.id,
                                        item.is_active
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {item.is_active === true ? (
                                      // ✅ Active Switch SVG with "Yes"
                                      <svg
                                        width="70"
                                        height="30"
                                        viewBox="0 0 70 30"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <rect
                                          width="70"
                                          height="30"
                                          rx="15"
                                          fill="#007bff"
                                        />
                                        <circle
                                          cx="52"
                                          cy="15"
                                          r="12"
                                          fill="white"
                                        />
                                        <text
                                          x="10"
                                          y="20"
                                          fill="white"
                                          fontSize="12"
                                          fontWeight="bold"
                                          fontFamily="Arial, sans-serif"
                                        >
                                          Yes
                                        </text>
                                      </svg>
                                    ) : (
                                      // ❌ Inactive Switch SVG with "No"
                                      <svg
                                        width="70"
                                        height="30"
                                        viewBox="0 0 70 30"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <rect
                                          width="70"
                                          height="30"
                                          rx="15"
                                          fill="#dc3545"
                                        />
                                        <circle
                                          cx="18"
                                          cy="15"
                                          r="12"
                                          fill="white"
                                        />
                                        <text
                                          x="38"
                                          y="20"
                                          fill="white"
                                          fontSize="12"
                                          fontWeight="bold"
                                          fontFamily="Arial, sans-serif"
                                        >
                                          No
                                        </text>
                                      </svg>
                                    )}
                                  </div>
                                </td>

                                <td style={{ fontSize: "14px" }}>
                                  <div style={{ display: "flex", gap: "8px" }}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      onClick={() =>
                                        Navigate("/admin/cms/show", {
                                          state: {
                                            id: item?.id,
                                            name: item?.name,
                                            status: item?.is_active,
                                          },
                                        })
                                      }
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="#515365"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye m-1 view_svg_color"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                      <circle cx="12" cy="12" r="3"></circle>
                                    </svg>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      onClick={() =>
                                        Navigate("/admin/cms/edit", {
                                          state: {
                                            id: item?.id,
                                            name: item?.name,
                                            status: item?.is_active,
                                          },
                                        })
                                      }
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="#515365"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-edit m-1 edit_svg_color"
                                    >
                                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                    </svg>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      onClick={() => HandleDelete(item?.id)}
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="#515365"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-trash m-1 delete_svg_color"
                                    >
                                      <polyline points="3 6 5 6 21 6"></polyline>
                                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                      <line
                                        x1="10"
                                        y1="11"
                                        x2="10"
                                        y2="17"
                                      ></line>
                                      <line
                                        x1="14"
                                        y1="11"
                                        x2="14"
                                        y2="17"
                                      ></line>
                                    </svg>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td
                              colSpan={5}
                              className="d-grid text-center fw-bold"
                            >
                              <h5>No Record Found</h5>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex justify-content-center">
                    <div
                      className="dataTables_paginate paging_full_numbers"
                      id="alter_pagination_paginate"
                    >
                      {data?.length !== 0 ? (
                        <ReactPaginate
                          previousLabel={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#515365"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-arrow-left"
                            >
                              <line x1="19" y1="12" x2="5" y2="12"></line>
                              <polyline points="12 19 5 12 12 5"></polyline>
                            </svg>
                          }
                          nextLabel={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#515365"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-arrow-right"
                            >
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                              <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                          }
                          breakLabel={"..."}
                          pageCount={totalpage}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={2}
                          onPageChange={handlePageClick}
                          containerClassName={
                            "pagination justify-content-end m-0"
                          }
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextClassName={"page-item"}
                          nextLinkClassName={"page-link"}
                          breakClassName={"page-item"}
                          breakLinkClassName={"page-link"}
                          activeClassName={"active"}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default CMS;
